import { render } from "./bookCreate.vue?vue&type=template&id=415725a2"
import script from "./bookCreate.vue?vue&type=script&lang=js"
export * from "./bookCreate.vue?vue&type=script&lang=js"

import "./bookCreate.vue?vue&type=style&index=0&id=415725a2&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__